module.exports = __webpack_public_path__ + "img/2.c610351c.png";